import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';
import { Button, Box, Paper } from '@mui/material';
import Input from '@mui/material/TextField';

import { showErrorNotification } from '../../redux/actions';
import CouponInput from './CouponInput';

export type VoucherFormProps = {
  onSubmit: (codePrefix?: string, code?: string) => void;
  errorMessage: string|React.ReactNode;
};

const VoucherForm: React.FC<VoucherFormProps> = (
  { onSubmit, errorMessage }: VoucherFormProps,
) => {
  const dispatch = useDispatch();
  const [codePrefix, setCodePrefix] = useState<string>();
  const [codeInput, setCodeInput] = useState<string>();
  const [clipboardText1, setClipboardText1] = useState<string>();
  const [clipboardText2, setClipboardText2] = useState<string>();

  const onClipboardPaste = (e: React.ClipboardEvent) => {
    const cbText = e.clipboardData.getData('text');
    const regexTest = /\b([\w\d]{4}-[\w\d]{6})\b/.test(cbText);
    if (!regexTest) {
      dispatch(showErrorNotification(<FormattedMessage id="voucher.invalidFormatting" />));
      return;
    }
    const splitCode = cbText.split('-');
    setClipboardText1(splitCode[0]);
    setClipboardText2(splitCode[1]);
    // empty clipboard state for next update to run if same text is pasted from clipboard
    setTimeout(() => {
      setClipboardText1('');
      setClipboardText2('');
    }, 100);
  };

  return (
    <Paper sx={{ p: '30px', maxWidth: '620px' }} variant="outlined">
      <h2><FormattedMessage id="voucher.redeemVoucher" /></h2>
      <Box sx={{ my: '20px' }}>
        <CouponInput
          fields={4}
          onChange={setCodePrefix}
          onPaste={onClipboardPaste}
          text={clipboardText1}
        />
        <Input
          disabled
          value="&#8212;"
          sx={{ width: 40, mx: '5px' }}
          variant="outlined"
        />
        <CouponInput
          fields={6}
          onChange={setCodeInput}
          onPaste={onClipboardPaste}
          text={clipboardText2}
        />
      </Box>
      <Box sx={{ textAlign: 'center', mt: '27px' }}>
        <Button onClick={() => onSubmit(codePrefix, codeInput)} className="w-30" color="primary" variant="contained">
          <FormattedMessage id="registration.submit" />
        </Button>
      </Box>
      {
        errorMessage
        && <p style={{ color: 'red', textAlign: 'justify' }}>{errorMessage}</p>
      }
    </Paper>
  );
};

export default VoucherForm;
